
/* injects from baggage-loader */

'use strict';

export default function (app) {
  app
  .factory('Dialog', DialogFactory);

  function DialogFactory($uibModal, $document) {
    'ngInject';

    let self = {};

    let modalParent = angular.element($document[0].querySelector('.stage-container'));

    self.showFail = function(title, text, callback, cancelFn){
      $uibModal.open({        
        component: 'dialogAlert',
        controllerAs: "$ctrl",
        resolve:{
          title: () => title,
          text: () => text
        },
        appendTo: modalParent,
        windowClass: 'alert-modal'
      }).result.then(callback, cancelFn);
    };

    self.showAlert = function(label, text, callback, cancelFn){
      $uibModal.open({        
        component: 'dialogAlert',
        controllerAs: "$ctrl",
        resolve:{
          label: () =>  label,
          text: () => text
        },
        appendTo: modalParent,
        windowClass: 'alert-modal',
        backdrop: 'static',
      }).result.then(callback, cancelFn);
    };

    self.showBigAlert = function(label, text, callback, cancelFn){
      $uibModal.open({        
        component: 'dialogAlert',
        controllerAs: "$ctrl",
        resolve:{
          label: () =>  label,
          text: () => text
        },
        appendTo: modalParent,
        windowClass: 'alert-lg-modal',
        backdrop: 'static',
      }).result.then(callback, cancelFn);
    };

    self.showSelectMonkey = function(model, callback, cancelFn){
      $uibModal.open({        
        component: 'dialogSelectMonkey',
        controllerAs: "$ctrl",
        resolve:{
          model: () => model
        },
        appendTo: modalParent,
        windowClass: 'select-monkey',
        backdrop: 'static',
      }).result.then(callback, cancelFn);
    };

    self.showOnca = function(texts, callback, cancelFn){
      $uibModal.open({        
        component: 'dialogApresentation',
        controllerAs: "$ctrl",
        resolve:{
          texts: () => texts
        },
        windowClass: 'alert-apresentation-onca',        
        appendTo: modalParent,
        backdrop: 'static',
      }).result.then(callback, cancelFn);
    };

    self.showTamandua = function(texts, callback, cancelFn){
      $uibModal.open({        
        component: 'dialogApresentation',
        controllerAs: "$ctrl",
        resolve:{
          texts: () => texts
        },
        windowClass: 'alert-apresentation-tamandua',        
        appendTo: modalParent,
        backdrop: 'static',
      }).result.then(callback, cancelFn);
    };

    self.showMacaco = function(texts, callback, cancelFn){
      $uibModal.open({        
        component: 'dialogApresentation',
        controllerAs: "$ctrl",
        resolve:{
          texts: () => texts
        },
        windowClass: 'alert-apresentation-macaco',        
        appendTo: modalParent,
        backdrop: 'static',
      }).result.then(callback, cancelFn);
    };

    self.showPeixeboi = function(texts, callback, cancelFn){
      $uibModal.open({        
        component: 'dialogApresentation',
        controllerAs: "$ctrl",
        resolve:{
          texts: () => texts
        },
        windowClass: 'alert-apresentation-peixeboi',        
        appendTo: modalParent,
        backdrop: 'static',
      }).result.then(callback, cancelFn);
    };
    
    self.showGraphOnca = function(model,  callback, cancelFn){
      $uibModal.open({        
        component: 'dialogGraphOnca',
        controllerAs: "$ctrl",
        resolve:{
          model: () => model,
        },
        windowClass: 'graph-onca-modal',
        appendTo: modalParent,        
        backdrop: 'static',
        keyboard: false
      }).result.then(callback, cancelFn);
    };

    self.showQuizOnca = function(model, onQuizCorrect, callback, cancelFn){
      $uibModal.open({        
        component: 'dialogQuizOnca',
        controllerAs: "$ctrl",
        resolve:{
          model: () => model,
          onQuizCorrect: () => onQuizCorrect
        },
        appendTo: modalParent,
        windowClass: 'quiz-onca-modal',
        backdrop: 'static',
        keyboard: false
      }).result.then(callback, cancelFn);
    };

    self.showQuizMacaco = function(label, model, onQuizCorrect, callback, cancelFn){
      $uibModal.open({        
        component: 'dialogQuizMacaco',
        controllerAs: "$ctrl",
        resolve:{
          label: () => label,
          model: () => model,
          onQuizCorrect: () => onQuizCorrect
        },
        appendTo: modalParent,
        windowClass: 'quiz-macaco-modal',
        backdrop: 'static',
        keyboard: false
      }).result.then(callback, cancelFn);
    };

    self.showDaily = function(label, callback, cancelFn){
      $uibModal.open({        
        component: 'dialogDaily',
        controllerAs: "$ctrl",
        resolve:{
          label: () => label
        },
        appendTo: modalParent,
        windowClass: 'daily-modal',
        backdrop: 'static',
        keyboard: false
      }).result.then(callback, cancelFn);
    };

    self.showQuizTamandua = function(model, callback, cancelFn){
      $uibModal.open({        
        component: 'dialogQuizTamandua',
        controllerAs: "$ctrl",
        resolve:{
          model: () => model,
        },
        appendTo: modalParent,
        windowClass: 'quiz-tamandua-modal',
        backdrop: 'static',
        keyboard: false
      }).result.then(callback, cancelFn);
    };

    self.showQuizTamanduaB = function(model, callback, cancelFn){
      $uibModal.open({        
        component: 'dialogQuizTamanduaB',
        controllerAs: "$ctrl",
        resolve:{
          model: () => model,
        },
        appendTo: modalParent,
        windowClass: 'quiz-tamandua-b-modal',
        backdrop: 'static',
        keyboard: false
      }).result.then(callback, cancelFn);
    };

    self.showQuizTamanduaC = function(model, callback, cancelFn){
      $uibModal.open({        
        component: 'dialogQuizTamanduaC',
        controllerAs: "$ctrl",
        resolve:{
          model: () => model,
        },
        appendTo: modalParent,
        windowClass: 'quiz-tamandua-c-modal',
        backdrop: 'static',
        keyboard: false
      }).result.then(callback, cancelFn);
    };

    self.showGraphPeixeboi = function(model,  callback, cancelFn){
      $uibModal.open({        
        component: 'dialogGraphOnca',
        controllerAs: "$ctrl",
        resolve:{
          model: () => model,
        },
        windowClass: 'graph-onca-modal',
        appendTo: modalParent,        
        backdrop: 'static',
        keyboard: false
      }).result.then(callback, cancelFn);
    };

    self.showQuizPeixeboi = function(question, model, onQuizCorrect, callback, cancelFn){
      $uibModal.open({        
        component: 'dialogQuizPeixeboi',
        controllerAs: "$ctrl",
        backdropClass: 'back-peixeboi',
        resolve:{
          model: () => model,
          onQuizCorrect: () => onQuizCorrect,
          question:() => question
        },
        appendTo: modalParent,
        windowClass: 'quiz-peixeboi-modal',
        backdrop: 'static',
        keyboard: false
      }).result.then(callback, cancelFn);
    };

    self.showConfirm = function(text, callback, cancelFn){
      $uibModal.open({        
        component: 'dialogConfirm',
        controllerAs: "$ctrl",
        resolve:{
          text: () => text
        },
        windowClass: 'confirm-modal',
        appendTo: modalParent,        
      }).result.then(callback, cancelFn);
    };

    self.showFeedback = function(label, texts, confirmBtn, callback, cancelFn){
      $uibModal.open({        
        component: 'dialogFeedback',
        controllerAs: "$ctrl",
        resolve:{
          label: () => label,
          texts: () => texts,
          confirmBtn: () => confirmBtn,
        },
        appendTo: modalParent,          
        windowClass: 'feedback-modal',
        backdrop: 'static',
      }).result.then(callback, cancelFn).catch(cancelFn);
    };

    self.showFeedbackIbama = function(label, texts, callback, cancelFn){
      $uibModal.open({        
        component: 'dialogFeedbackIbama',
        controllerAs: "$ctrl",
        resolve:{
          label: () => label,
          texts: () => texts,
        },
        appendTo: modalParent,
        windowClass: 'feedback-ibama',
        backdrop: 'static',
      }).result.then(callback, cancelFn).catch(cancelFn);
    };

    self.showTrophy = function(animal, texts, callback, cancelFn){
      $uibModal.open({        
        component: 'dialogTrophy',
        controllerAs: "$ctrl",
        backdrop: 'static',
        resolve:{
          animal: () => animal,
          texts: () => texts
        },
        appendTo: modalParent,
        windowClass: 'feedback-trophies'
      }).result.then(callback, cancelFn).catch(cancelFn);
    };

    self.showIntroModal = function(callback, cancelFn){
      $uibModal.open({
        animation: false,
        component: 'dialogIntro',
        controllerAs: "$ctrl",
        backdrop: false,
        keyboard: false,
        windowClass: 'interventional-modal',
      }).result.then(callback, cancelFn);
    };  
    
    self.showInterventionalModal = function(title, ballons, callback, cancelFn){
      $uibModal.open({
        animation: false,
        component: 'dialogInterventional',
        controllerAs: "$ctrl",
        backdrop: false,
        keyboard: false,
        windowClass: 'interventional-modal',
        resolve: {
          title: () =>  title,
          ballons: () => ballons
        },
        appendTo: modalParent
      }).result.then(callback, cancelFn);
    };    

    return self;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/dialogs.factory.js